type LenderOption = {
  value: string | number | boolean;
  label: string;
};

/** Alphabetical by translated label, with Other pinned to the bottom. */
export const sortLenderOptions = <T extends LenderOption>(
  options: T[]
): T[] => {
  const others = options.filter((option) => option.value === "OTHER");
  const rest = options
    .filter((option) => option.value !== "OTHER")
    .sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    );

  return [...rest, ...others];
};
